import EditDiscount from "pages/secure/facility/settings/discount/DiscountEdit";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as UIActions from "redux/actions/ui";

const mapDispatchToProps = (dispatch: any) => {
  return {
    uiActions: bindActionCreators(
      {
        ...UIActions,
      },
      dispatch,
    ),
  };
};

const mapStateToProps = (state: any) => {
  return {
    authStore: { ...state.authStore },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditDiscount);
